import React, { JSX, Suspense } from 'react';
import { QueryLoadingCentered } from '@ankr.com/raas-ui';
import { lazily } from '@ankr.com/raas-utils';
import { Box } from '@mui/material';

import { useSidebarStyles } from './useSidebarStyles';

const { MainMenu } = lazily(() => import('../MainMenu'));

export function Sidebar(): JSX.Element {
  const { classes } = useSidebarStyles();

  return (
    <Box component="aside" className={classes.root}>
      <Suspense fallback={<QueryLoadingCentered size={20} />}>
        <MainMenu />
      </Suspense>
    </Box>
  );
}
